import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { Subject } from 'rxjs';
import {NextPimField} from "../../Model/Catalog/NextPimField";

@Component({
    selector: 'np-advanced-template-fixed',
    templateUrl: './advanced-template-fixed.component.html',
    standalone: false
})
export class AdvancedTemplateFixedComponent implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  @Input() templateItem!: TemplateItem;
  @Input() pimField?: NextPimField;

  @Input() customerId: string;
  @Output() onUpdate = new EventEmitter<void>();

  get fixedValue(): string {
    if (this.pimField)
      return this.pimField.value ?? '';
    return this.templateItem.defaultValue ?? '';
  }

  set fixedValue(value: string) {
    if (this.pimField)
      this.pimField.value = value;
    else
      this.templateItem.defaultValue = value;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
